export function ActorName(props: { name: string }) {
  return <>{props.name}</>;
}
